import React from 'react';
import AddEditImeAssessments from '@components/case-details-routes/AddEditImeAssessments';

export default function IMEAssessmentDetail(props) {
  return <AddEditImeAssessments {...props} />;
}
